// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1ZVtY","content":"GlobalSearch_content__3ctAn"};